import { api } from './api';

export interface ApiKeyDto {
  id: number;
  name: string;
  prefix: string;
  scope: 'read' | 'write';
  /** Zusatzrechte, z. B. 'customers:sensitive' (Steuer- und Bankdaten). */
  zusatzScopes: string[];
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

/** Antwort beim Anlegen — `key` ist der EINZIGE Moment, in dem der Klartext existiert. */
export interface ApiKeyNeuDto extends Omit<ApiKeyDto, 'lastUsedAt' | 'revokedAt'> {
  key: string;
  hinweis: string;
}

export const listApiKeys = () => api.get<ApiKeyDto[]>('/api/api-keys');

export const SCOPE_SENSIBEL = 'customers:sensitive';

export const createApiKey = (name: string, scope: 'read' | 'write', zusatzScopes: string[] = []) =>
  api.post<ApiKeyNeuDto>('/api/api-keys', { name, scope, zusatzScopes });

export const setApiKeyZusatzScopes = (id: number, zusatzScopes: string[]) =>
  api.patch<ApiKeyDto>(`/api/api-keys/${id}`, { zusatzScopes });

export const revokeApiKey = (id: number) =>
  api.delete<{ id: number; revokedAt: string }>(`/api/api-keys/${id}`);

// ── Webhook-Ziele je Schlüssel (öffentliche API v1) ─────────────────────────

export interface WebhookZielDto {
  id: number;
  url: string;
  events: string[];
  aktiv: boolean;
  fehlerInFolge: number;
  deaktiviertAm: string | null;
  deaktiviertGrund: string | null;
  beschreibung: string | null;
  angelegtAm: string;
}

export interface WebhookZielNeuDto extends WebhookZielDto {
  secret: string;
  hinweis: string;
}

export interface WebhookVersuchDto {
  am: string;
  event: string;
  deliveryId: string;
  versuch: number;
  httpStatus: number | null;
  dauerMs: number;
  ergebnis: 'success' | 'retry' | 'failed' | 'aufgegeben';
  fehler: string | null;
}

const zielPfad = (keyId: number, rest = '') => `/api/api-keys/${keyId}/webhooks${rest}`;

export const listWebhookZiele = (keyId: number) => api.get<WebhookZielDto[]>(zielPfad(keyId));
export const createWebhookZiel = (keyId: number, url: string, events: string[], beschreibung?: string) =>
  api.post<WebhookZielNeuDto>(zielPfad(keyId), { url, events, beschreibung });
export const updateWebhookZiel = (keyId: number, id: number, daten: Partial<Pick<WebhookZielDto, 'url' | 'events' | 'aktiv' | 'beschreibung'>>) =>
  api.patch<WebhookZielDto>(zielPfad(keyId, `/${id}`), daten);
export const deleteWebhookZiel = (keyId: number, id: number) => api.delete<{ ok: true }>(zielPfad(keyId, `/${id}`));
export const testWebhookZiel = (keyId: number, id: number) =>
  api.post<{ deliveryId: string; ergebnis: string; httpStatus: number | null; dauerMs: number; fehler: string | null }>(zielPfad(keyId, `/${id}/test`));
export const webhookProtokoll = (keyId: number, id: number) => api.get<WebhookVersuchDto[]>(zielPfad(keyId, `/${id}/deliveries`));
